"use strict";
/*
 * Created on 25.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("../../core/model/AdtFlag");

var utils_1 = require("../../core/utils"); // tslint:disable:max-classes-per-file

/**
 * @author MSu
 */


var SessionFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(SessionFlag, _AdtFlag_1$AdtFlag);

  function SessionFlag() {
    _classCallCheck(this, SessionFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(SessionFlag).apply(this, arguments));
  }

  _createClass(SessionFlag, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(SessionFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(SessionFlag, data);
    }
  }]);

  return SessionFlag;
}(AdtFlag_1.AdtFlag);

exports.SessionFlag = SessionFlag;
SessionFlag.TAG = '__SessionFlag__';

var UserSession =
/*#__PURE__*/
function (_SessionFlag) {
  _inherits(UserSession, _SessionFlag);

  function UserSession() {
    _classCallCheck(this, UserSession);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserSession).apply(this, arguments));
  }

  _createClass(UserSession, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return UserSession;
}(SessionFlag);

exports.UserSession = UserSession;
UserSession.TAG = SessionFlag.register(UserSession);

var SnapshotSession =
/*#__PURE__*/
function (_SessionFlag2) {
  _inherits(SnapshotSession, _SessionFlag2);

  function SnapshotSession(state) {
    var _this;

    _classCallCheck(this, SnapshotSession);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SnapshotSession).call(this));
    _this.state = state;
    return _this;
  }

  _createClass(SnapshotSession, [{
    key: "validate",
    value: function validate() {
      return !utils_1.Utils.isValueMissing(this.state);
    }
  }]);

  return SnapshotSession;
}(SessionFlag);

exports.SnapshotSession = SnapshotSession;
SnapshotSession.TAG = SessionFlag.register(SnapshotSession);